import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-punitorio',
  templateUrl: './btn-nuevo-tipo-punitorio.component.html',
  styleUrls: ['./btn-nuevo-tipo-punitorio.component.css']
})
export class BtnNuevoTipoPunitorioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
